import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";

const LISTADO_PRESENTACION = 'LISTADO_PRESENTACION';
const GUARDAR_PRESENTACION = 'GUARDAR_PRESENTACION';
const LOADER = 'LOADER';
const MODULO = 'MODULO';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id };
    api.get('/presentacion_producto', params).then((response)=>{
        dispatch({ type: LISTADO_PRESENTACION, data: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al listar presentaciones de producto',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroPresentacionProducto = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormPresentacionProducto.values;
    const formData = {
        presentacion: data.presentacion,
        empresa: id_emp[5]
    }
    dispatch(setLoader(true));
    api.post('/presentacion_producto/', formData).then((response) => {
        NotificationManager.success(
            'Presentacion de producto creado',
            'Exito',
            3000
        );
        let ruta = `/inventario/${id_emp[5]}/presentacion_producto`
        dispatch(push(ruta));
    }).catch((error) => {
    NotificationManager.error(
        error.msj,
        'Error',
        2000
    );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const modificarPresentacionProducto = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormPresentacionProducto.values;
    const id = datos.id;
    const formData = {
        id: id,
        presentacion: datos.presentacion,
    }
    dispatch(setLoader(true));
    api.put(`/presentacion_producto/${id}/`, formData).then((response) => {
        NotificationManager.success(
            'Presentacion de producto modificado correctamente',
            'Exito',
            3000
        );
        let ruta = `/inventario/${id_emp[5]}/presentacion_producto`
        dispatch(push(ruta));
    }).catch((error) => {
        NotificationManager.error(
            error.msj,
            'Error',
            8000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/presentacion_producto/${id}`).then((response) => {
        dispatch({type: GUARDAR_PRESENTACION, lectura: response });
        dispatch(initializeForm('FormPresentacionProducto', response ));
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al consultar presentacion de producto',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actions = {
    listar,
    registroPresentacionProducto,
    modificarPresentacionProducto,
    leer,
    getModulo
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_PRESENTACION]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [GUARDAR_PRESENTACION]: (state, { lectura }) => {
        return {
            ...state,
            lectura,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
};

export const initialState = {
    loader: false,
    lectura: [],
    modulo: [],
    data: [],
};

export default handleActions(reducers, initialState)
